module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-collector-3.9c950791.svg";